<template>
    <div class="IperMatrizPeligrosOpciones">
        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-block dropdown-toggle" :class="{
                'btn_pendiente': matriz.estado,
                'boton_12': !matriz.estado
            }" data-toggle="dropdown" aria-expanded="false"></button>
            <ul class="dropdown-menu b-dropdown-opt" role="menu">
                <div class="scroll-options">
                    <li>
                        <router-link v-if="$store.state.global_privilegio_matriz_peligro.consultar"
                            class="btn btn-block mi_boton pull-left"
                            :to="'/lista_clientes/consultar_matriz/' + matriz.id">
                            Consultar
                        </router-link>
                        <a v-if="$store.state.global_privilegio_matriz_peligro.editar"
                            class="btn btn-block mi_boton pull-left" @click="editarMatriz(matriz.id)">
                            &nbsp;Editar
                        </a>
                        <router-link v-if="$store.state.global_privilegio_matriz_peligro.editar"
                            class="btn btn-block mi_boton pull-left"
                            :to="'/lista_clientes/importar_matriz/' + matriz.id">
                            &nbsp;Editar Por Importación
                        </router-link>
                        <a v-if="$store.state.global_privilegio_matriz_peligro.eliminar"
                            class="btn btn-block mi_boton pull-left" @click="eliminarMatriz(matriz.id)">
                            &nbsp;Eliminar
                        </a>
                        <a v-if="$store.state.global_privilegio_matriz_peligro.descargar_excel"
                            class="btn btn-block mi_boton pull-left" @click="esDescargar = true; idMatriz = matriz.id">
                            &nbsp;Descargar Excel
                        </a>
                        <router-link v-if="$store.state.global_privilegio_matriz_peligro.copiar_matriz"
                            class="btn btn-block mi_boton pull-left" :to="'/lista_clientes/copiar_matriz/' + matriz.id">
                            Copiar Matriz
                        </router-link>
                        <a v-if="$store.state.global_privilegio_matriz_peligro.control_cambios"
                            class="btn btn-block mi_boton pull-left" data-toggle="modal"
                            :data-target="'#controlCambios' + matriz.id"
                            @click="esControlCambios = true; idMatriz = matriz.id">
                            Control Cambios
                        </a>
                        <!-- <a
                      class="btn btn-block mi_boton pull-left"
                      data-toggle="modal"
                      data-target="#permisos_matriz"
                      @click="idClientShare = props.row.id"
                    >
                      Compartir Matriz
                    </a> -->
                        <a v-if="$store.state.global_privilegio_matriz_peligro.verificacion_cyd"
                            class="btn btn-block mi_boton pull-left" data-toggle="modal"
                            :data-target="'#verificacionCYD' + matriz.id"
                            @click="esVerificacionCYD = true; idMatriz = matriz.id">
                            &nbsp;Verificación C&D
                        </a>
                    </li>
                </div>
            </ul>
            <DescargarExcel v-if="esDescargar" :id="idMatriz" @descargarExcel="obtenerDescargarExcel" />
            <ControlCambios v-if="esControlCambios" :id="idMatriz" />
            <VerificacionCYD v-if="esVerificacionCYD" :id="idMatriz" />
        </div>
    </div>
</template>

<script>
import { db } from '@/firebase'
import Swal from 'sweetalert2';
import DescargarExcel from './Acciones/DescargarExcel.vue';
import VerificacionCYD from './Acciones/VerificacionCYD.vue';
import ControlCambios from './Acciones/ControlCambios/ControlCambios.vue';
export default {
    name: "IperMatrizPeligrosOpciones",

    components: {
        DescargarExcel,
        ControlCambios,
        VerificacionCYD,
    },

    props: {
        matriz: Object
    },

    data() {
        return {
            idMatriz: "",
            esDescargar: false,
            esControlCambios: false,
            esVerificacionCYD: false,
        };
    },

    methods: {
        async editarMatriz(id) {
            await this.$store.commit("mutation_limpiar_globales");
            this.$store.state.msp_c_key = id;
            this.$store.state.estado_navbar_matriz_peligro = "registro_centro_trabajo";
            this.$router.replace("/matriz_peligro");
        },

        obtenerDescargarExcel(data) {
            this.esDescargar = data;
        },

        async eliminarMatriz(id) {
            if (this.$store.state.global_privilegio_matriz_peligro.eliminar) {
                Swal.fire({
                    title: "¿Seguro que deseas eliminar este Centro de Trabajo?",
                    text: "¡Una vez eliminado, no podrás volver a ver el Centro de Trabajo!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Eliminar",
                    cancelButtonText: "Cancelar",
                }).then((result) => {
                    if (result.value) {
                        db.collection("cliente_empresa").doc(id).update({
                            em_baja: false,
                        }).then(() => {
                            Swal.fire("¡Eliminado!", "Centro de Trabajo eliminado correctamente", "success");
                        }).catch((error) => {
                            console.error("Error updating MATRIZ RIESGO ID PELIGRO: ", error);
                        });
                    }
                });
            }
        }
    },
}
</script>

<style scoped>
.scroll-options {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 120px;
    width: 100%;
    z-index: 5 !important;
}

::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: gray;
    border-radius: 10px;
}

::-webkit-scrollbar-corner {
    background: transparent;
    border-radius: 10px;
}
</style>